import { getCurrentLanguage } from 'utils/src/getCurrentLanguage';
import { apiClient } from '../../../../apps/crossword-maker/src/shared/apiClient';
import {
  PaginationResponseData,
  RestApiErrorType,
} from '../../../../apps/crossword-maker/src/shared/types/RestApi.types';
import { IUserApiEntity, IUserApiRequestParams } from './User.api.types';

export type TGetMany = (
	data?: IUserApiRequestParams,
) => Promise<IUserApiEntity[]>;

export const getMany: TGetMany = async (data) => {
	const language = getCurrentLanguage();

	const response = await apiClient().get<
		PaginationResponseData<IUserApiEntity> | RestApiErrorType
	>(`/rest/${language}/users`, { params: { ...data } });

	return response.data.items;
};
